import script from "./IPackageEventName.vue?vue&type=script&setup=true&lang=js"
export * from "./IPackageEventName.vue?vue&type=script&setup=true&lang=js"

import "./IPackageEventName.vue?vue&type=style&index=0&id=168f2862&lang=scss"

const __exports__ = script;

export default __exports__